import { StandardEvents } from '@shopify/events';

class TiffanySizeBadge extends HTMLElement {
  connectedCallback() {
    if (this.dataset.stylesheet) {
      const href = new URL(this.dataset.stylesheet, document.baseURI).href;
      if (![...document.querySelectorAll('link[rel="stylesheet"]')].some(link => link.href === href)) {
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = href;
        document.head.append(link);
      }
    }
    this.controller?.abort();
    this.controller = new AbortController();
    const { signal } = this.controller;
    this.scope = this.closest('product-card') || this.closest('.shopify-section');
    this.gallery = this.closest('.card-gallery, maison-product-gallery');
    this.selectedVariant = this.dataset.variantId;
    this.sequence = 0;
    this.scope?.addEventListener(StandardEvents.productSelect, async (event) => {
      if (!event.promise || (this.dataset.context === 'product' && event.target.closest?.('product-card'))) return;
      const sequence = ++this.sequence;
      try {
        const { detail } = await event.promise;
        if (!this.isConnected || sequence !== this.sequence || !detail?.html) return;
        const candidates = [...detail.html.querySelectorAll('tiffany-size-badge')];
        const source = candidates.find(el => el.dataset.productId === this.dataset.productId && el.dataset.context === this.dataset.context)
          || candidates.find(el => el.dataset.productId === this.dataset.productId);
        if (!source) { this.querySelector('[data-size-current]')?.replaceChildren(); return; }
        this.replaceChildren(...[...source.childNodes].map(node => node.cloneNode(true)));
        this.dataset.variantId = source.dataset.variantId;
        this.selectedVariant = source.dataset.variantId;
        this.showVariant(this.selectedVariant);
      } catch { /* Keep the last confirmed variant if the native request fails. */ }
    }, { signal });
    this.gallery?.addEventListener('slideshow:select', (event) => {
      const slide = event.detail?.slide;
      const id = slide?.getAttribute('slide-id') || slide?.dataset.mediaId || slide?.querySelector('[data-media-id]')?.dataset.mediaId;
      const matches = id ? [...this.querySelectorAll('template[data-size-variant]')].filter(t => t.dataset.mediaId === String(id)) : [];
      // A shared photograph cannot identify a size: retain the selected variant.
      const match = matches.find(t => t.dataset.sizeVariant === this.selectedVariant) || (matches.length === 1 ? matches[0] : null);
      this.showVariant(match?.dataset.sizeVariant || this.selectedVariant);
    }, { signal });
    if (this.dataset.context === 'product') {
      const stage = this.gallery?.querySelector('media-gallery > slideshow-component > slideshow-container');
      if (stage && this.parentElement !== stage) { stage.append(this); return; }
    }
  }
  showVariant(id) {
    const source = [...this.querySelectorAll('template[data-size-variant]')].find(t => t.dataset.sizeVariant === String(id));
    const target = this.querySelector('[data-size-current]');
    if (source && target) target.replaceChildren(source.content.cloneNode(true));
  }
  disconnectedCallback() { this.controller?.abort(); this.sequence++; }
}
if (!customElements.get('tiffany-size-badge')) customElements.define('tiffany-size-badge', TiffanySizeBadge);
